import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatebushireindaund() {



  const cardData =
  {
    keyword: 'Corporate Bus Hire in Daund',
    heading: 'Sanavi Travels: Corporate Bus Hire in Daund',
    headingDescription: 'Sanavi Travels offers reliable Corporate Bus Hire in Daund, providing safe, comfortable, and professional transportation for corporate events, office outings, team-building trips, conferences, and business travel. Our fleet of well-maintained AC and non-AC buses, mini buses, and luxury coaches ensures spacious seating, smooth rides, and a hassle-free travel experience. With experienced drivers, flexible full-day and hourly corporate bus packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient pickup and drop services across Daund and surrounding areas, covering major corporate hubs, event venues, and offices. Choose Sanavi Travels for trusted corporate bus hire services in Daund, delivering comfort, safety, and seamless transportation for every business requirement.',

    top: 'Top Places to Visit in Daund with Sanavi Travels',


"topPlaces": [
  {
    "title": "Bhigwan Bird Sanctuary",
    "description": "Located near Daund, Bhigwan Bird Sanctuary is a paradise for bird lovers and nature enthusiasts. Often called the 'Bharatpur of Maharashtra,' it attracts migratory birds like flamingos, pelicans, and storks, especially during winter. Boat safaris and sunrise views make it a must-visit destination."
  },
  {
    "title": "Ujani Dam Backwaters",
    "description": "The backwaters of Ujani Dam near Daund offer a serene landscape of vast water spread and open skies. The area is ideal for peaceful outings, photography, and birdwatching, particularly during early mornings and evenings."
  },
  {
    "title": "Shri Siddheshwar Temple",
    "description": "Shri Siddheshwar Temple is an important local religious site in Daund, attracting devotees throughout the year. The temple is known for its calm spiritual atmosphere and traditional rituals performed during festivals."
  },
  {
    "title": "Daund Railway Junction",
    "description": "Daund Railway Junction is one of the major railway hubs in Maharashtra, connecting important routes toward Pune, Solapur, and southern India. The historic junction plays a vital role in trade, travel, and regional connectivity."
  },
  {
    "title": "Bhigwan Wetlands",
    "description": "The wetlands around Bhigwan near Daund support rich biodiversity and seasonal migratory birds. Nature walks and boat rides allow visitors to experience untouched natural beauty and rural landscapes."
  },
  {
    "title": "Local Sugar Factories Area",
    "description": "Daund is surrounded by sugarcane fields and sugar factories that represent the agricultural backbone of the region. These areas highlight rural life and Maharashtra’s cooperative farming culture."
  },
  {
    "title": "Village Temples and Wadas",
    "description": "Traditional village temples and old wadas around Daund reflect the cultural and architectural heritage of rural Maharashtra. These sites offer insight into local traditions, festivals, and community life."
  },
  {
    "title": "Indapur Road Countryside",
    "description": "The countryside along Indapur Road near Daund offers scenic drives with open fields, canals, and sunset views. It is ideal for short nature breaks and relaxed travel experiences."
  },
  {
    "title": "Local Weekly Markets",
    "description": "Weekly markets in Daund are vibrant centers of local trade, selling fresh produce, grains, livestock, and daily essentials. They provide an authentic experience of rural Maharashtra’s lifestyle."
  },
  {
    "title": "Pilgrimage Routes Nearby",
    "description": "Daund lies on important travel routes connecting Pune, Solapur, Pandharpur, and Bhigwan. Many pilgrims use Daund as a transit point while visiting major religious destinations."
  }
]
,



"services": [
  {
    "name": "Corporate Bus Hire in Daund",
    "description": "Corporate Bus Hire in Daund provides professional and reliable transportation for companies, ensuring smooth and comfortable travel for employees, clients, and business guests. Ideal for daily commutes, corporate events, meetings, and offsite visits, the service focuses on punctuality, safety, and organized group travel."
  },
  {
    "name": "Corporate Bus Rental Daund",
    "description": "Corporate Bus Rental Daund offers flexible rental options for companies of all sizes. Well-maintained, air-conditioned buses with experienced chauffeurs ensure safe, comfortable, and timely travel for staff commutes, corporate tours, and intercity business trips."
  },
  {
    "name": "AC Corporate Bus Daund",
    "description": "AC Corporate Bus Daund provides a cool and relaxing travel experience for employees and corporate groups. Fully air-conditioned interiors, spacious seating, and professional driving standards ensure a comfortable and productive journey for office staff and corporate travelers."
  },
  {
    "name": "Employee Transport Bus Daund",
    "description": "Employee Transport Bus Daund is designed to handle daily office commutes efficiently. Scheduled pickups, trained drivers, and comfortable air-conditioned buses provide a safe and stress-free travel solution for company employees, enhancing workforce mobility and punctuality."
  },
  {
    "name": "Company Bus Service Daund",
    "description": "Company Bus Service Daund offers organized and reliable bus transport for corporate clients. Suitable for staff transfers, industrial commutes, corporate events, and team outings, the service ensures safety, comfort, and professional chauffeur-driven travel."
  },
  {
    "name": "Affordable Corporate Bus Daund",
    "description": "Affordable Corporate Bus Daund provides cost-effective corporate transportation without compromising on quality or safety. Ideal for small businesses and budget-conscious companies, this service balances affordability with comfort and reliability for daily and long-distance travel."
  },
  {
    "name": "Chauffeur Driven Corporate Bus",
    "description": "Chauffeur Driven Corporate Bus ensures a stress-free and safe journey for corporate groups. Professional drivers manage navigation, traffic, and schedules, allowing passengers to focus on work, relaxation, or team activities during the trip."
  },
  {
    "name": "Best Corporate Bus Daund",
    "description": "Best Corporate Bus Daund delivers high-quality, dependable transportation for corporate clients. Well-maintained vehicles, experienced chauffeurs, and timely service make it ideal for business meetings, conferences, office staff commutes, and corporate events."
  },
  {
    "name": "Office Staff Bus Daund",
    "description": "Office Staff Bus Daund focuses on the safe and efficient transfer of employees between home and workplace. Air-conditioned buses with trained drivers provide reliability, punctuality, and comfort, ensuring smooth daily commutes for corporate staff."
  },
  {
    "name": "Industrial Bus Daund",
    "description": "Industrial Bus Daund is tailored for factories, industrial parks, and large enterprises. Designed to transport employees safely and efficiently, these buses offer comfort, organized routes, and professional driver service for workforce mobility."
  },
  {
    "name": "Group Travel Corporate Bus",
    "description": "Group Travel Corporate Bus facilitates comfortable and coordinated travel for corporate groups attending events, conferences, and team outings. Spacious, air-conditioned buses with skilled chauffeurs ensure a safe, punctual, and enjoyable journey for all passengers."
  },
  {
    "name": "Online Bus Booking Daund",
    "description": "Online Bus Booking Daund allows companies to reserve corporate buses conveniently via an online platform. With instant confirmation, customizable schedules, and flexible routes, businesses can plan employee transport efficiently and hassle-free."
  },
  {
    "name": "Business Travel Bus",
    "description": "Business Travel Bus provides tailored solutions for executives, teams, and corporate travelers attending meetings, site visits, and business trips. Air-conditioned comfort, punctual service, and professional drivers make intercity and local business travel smooth and reliable."
  },
  {
    "name": "Event Corporate Bus",
    "description": "Event Corporate Bus offers seamless transportation for conferences, seminars, exhibitions, and company events. Coordinated travel, timely arrivals, and comfortable seating ensure attendees reach their destinations safely and in style."
  },
  {
    "name": "Daund Corporate Transport",
    "description": "Daund Corporate Transport delivers comprehensive solutions for employee commuting, corporate events, and business travel. Well-maintained buses, professional chauffeurs, and flexible routes provide safe, reliable, and comfortable corporate mobility."
  }
],
"tableData": [
  ["Corporate Bus Hire in Daund", "Corporate Bus Rental Daund"],
  ["AC Corporate Bus Daund", "Employee Transport Bus Daund"],
  ["Company Bus Service Daund", "Affordable Corporate Bus Daund"],
  ["Chauffeur Driven Corporate Bus", "Best Corporate Bus Daund"],
  ["Office Staff Bus Daund", "Industrial Bus Daund"],
  ["Group Travel Corporate Bus", "Online Bus Booking Daund"],
  ["Business Travel Bus", "Event Corporate Bus"],
  ["Daund Corporate Transport", "—"]
]
,

"whychoose": [
  {
    "WhyChooseheading": "Corporate Bus Hire in Daund with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers professional and reliable corporate bus hire services in Daund, perfect for employee transportation, corporate events, team outings, and business travel."
  },
  {
    "WhyChooseheading": "Spacious and Well‑Maintained Buses",
    "WhyChoosedescription": "Our corporate buses are air‑conditioned, clean, and regularly serviced to provide a comfortable and smooth travel experience for your corporate group."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, punctual, and experienced in handling corporate routes and schedules, ensuring safe and timely transportation."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for corporate bus hire in Daund, including fuel, tolls, and driver allowances with no hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, route planning, and any changes to your corporate travel itinerary."
  },
  {
    "WhyChooseheading": "Flexible Booking Options",
    "WhyChoosedescription": "Choose from hourly, half‑day, full‑day, or customized corporate bus hire packages based on your business travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All corporate buses are thoroughly cleaned and sanitized before each trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for corporate bus hire in Daund."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels offer corporate bus hire services in Daund?',
    answer: 'Yes, Sanavi Travels provides professional corporate bus hire services in Daund for employee transportation, corporate events, and business travel.'
  },
  {
    question: 'How can I book a corporate bus in Daund?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for corporate hire?',
    answer: 'Sanavi Travels provides air‑conditioned, well‑maintained, and spacious buses suitable for corporate travel.'
  },
  {
    question: 'Are the drivers experienced for corporate travel?',
    answer: 'Yes, our drivers are professional, licensed, and experienced in handling corporate routes and schedules.'
  },
  {
    question: 'Can I hire a corporate bus for a few hours or a whole day?',
    answer: 'Absolutely. We offer hourly, half‑day, full‑day, and customized corporate bus hire packages.'
  },
  {
    question: 'Is the corporate bus hire service available 24x7?',
    answer: 'Yes, Sanavi Travels provides round‑the‑clock support for corporate bus hire services in Daund.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all corporate buses are thoroughly cleaned and sanitized before departure.'
  },
  {
    question: 'What payment options are available for corporate bus hire?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your corporate bus hire trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep Kulkarni',
    feedback: 'Hired a corporate bus for our office outing in Daund. Excellent service, punctual driver, and comfortable ride.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Anjali Patil',
    feedback: 'Sanavi Travels provided great corporate bus hire service. Smooth travel experience and very supportive staff.',
    rating: 5
  }
];


















































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Bus Hire in Daund - Sanavi Travels",
  "description": "Sanavi Travels provides corporate bus rental in Daund for employee transport, company events, industrial travel, and group trips. AC, chauffeur-driven, and affordable options available with online booking.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "275"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Corporate Bus Hire in Daund | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book corporate bus hire in Daund with Sanavi Travels for employee transport, company events, industrial travel, and group trips. AC, chauffeur-driven, and affordable buses available with online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/100.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatebushireindaund;